import { render, staticRenderFns } from "./ChatTopMessage.vue?vue&type=template&id=6fcea060&scoped=true"
import script from "./ChatTopMessage.vue?vue&type=script&lang=js"
export * from "./ChatTopMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatTopMessage.vue?vue&type=style&index=0&id=6fcea060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcea060",
  null
  
)

export default component.exports